export default __webpack_public_path__ + "static/media/Arm_right.c27eeff5.svg";